import * as React from 'react';
import * as PropTypes from 'prop-types';
import { delay } from 'lodash';
import { routeMap } from 'router';
import config from 'config';
import Loading from '../../../../components/Loading';
import Warning from '../../../../components/Warning';
import Link from '../../../../containers/LinkWrapperContainer';
import ContactInfoForm from './private/ContactInfoForm';
import submit from './private/submit';
import NotificationsSettings from 'modules/Profile/components/NotificationsSettings';
import './style.scss';
import REACT_CONFIG from 'REACT_CONFIG';
import { remotePaths } from 'router/routes';

export default class ContactInfo extends React.Component {
  static propTypes = {
    appConfig: PropTypes.shape({
      isInspectorArm: PropTypes.bool.isRequired,
    }).isRequired,
    user: PropTypes.shape({
      acceptHardCopy: PropTypes.bool.isRequired,
    }).isRequired,
    readOnly: PropTypes.bool,
    contactInfo: PropTypes.shape({
      address: PropTypes.string,
    }),
    loadData: PropTypes.func.isRequired,
    loadReadOnly: PropTypes.func.isRequired,
    updateData: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    resetTour: PropTypes.func,
  };

  state = {
    isShowPassword: false,
    saveSettings: false,
    innerError: false,
  };

  componentDidMount() {
    this.props.loadData();
    this.props.loadReadOnly();
  }

  componentDidUpdate() {
    if (this.state.saveSettings === true) {
      delay(() => {
        this.setState({ saveSettings: false });
      }, 3000);
    }
  }

  handleSubmit = (values, dispatch, props) => {
    return submit(values.toJS(), {
      isEmptyPassword: props.isEmptyPassword,
      hasCodeWord: props.hasCodeWord,
    }).then(() => {
      this.setState({ isShowPassword: false, saveSettings: true }, () => {
        props.updateContactData();
      });
    });
  };

  handleSubmitSuccess = (result, dispatch, props) => {
    props.change('oldPassword', '');
    props.change('newPassword1', '');
    props.change('newPassword2', '');
  };

  handleSubmitFailed = (formErrors) => {
    const needShowPasswordBlock = !!(
      formErrors.newPassword1 ||
      formErrors.newPassword2 ||
      formErrors.oldPassword
    );

    this.setState({
      saveSettings: false,
      isShowPassword: needShowPasswordBlock,
      innerError: formErrors._error,
      formErrors,
    });
  };

  handleResetTourClick = () => {
    this.props.resetTour();
  };

  renderHardCopyLink() {
    // const rejectHardCopyLink = injectParamsInRoute(routeMap.hardCopy, {
    //   actionType: hardCopyTypeMap[rejectHardCopy].actionType,
    // });
    // const resolveHardCopyLink = injectParamsInRoute(routeMap.hardCopy, {
    //   actionType: hardCopyTypeMap[resolveHardCopy].actionType,
    // });

    const { user } = this.props;

    if (user.acceptHardCopy) {
      return (
        <div className="page_margin20">
          <a href={remotePaths.refusalHardCopy}>
            {'Отказаться от получения документов на бумажном носителе'}
          </a>
        </div>
      );
    }

    return (
      <div className="page_margin20">
        <a href={remotePaths.needHardCopy}>{'Получать документы на бумажном носителе'}</a>
      </div>
    );
  }

  renderContentInfo = () => {
    const { appConfig, readOnly, contactInfo } = this.props;

    return (
      <div className={'white-block__pad40 pt-0'}>
        <ContactInfoForm
          isReadOnly={readOnly}
          onSubmit={this.handleSubmit}
          onSubmitFail={this.handleSubmitFailed}
          onSubmitSuccess={this.handleSubmitSuccess}
          isInspectorArm={appConfig.isInspectorArm}
          contactInfo={contactInfo}
          innerError={this.state.innerError}
          setInnerError={(innerError) => this.setState({ innerError })}
          isShowPassword={this.state.isShowPassword}
          isSavedSettings={this.state.saveSettings}
          onChange={() => this.state.innerError && this.setState({ innerError: null })}
          toggleChangePassword={() => this.setState({ isShowPassword: !this.state.isShowPassword })}
          updateContactData={this.props.updateData}
          formErrors={this.state.formErrors}
        />

        {config.enableNotificationsCenter && (
          <div className="white-block_border white-block_border__bottom">
            <NotificationsSettings />
          </div>
        )}

        <div className="white-block_border white-block_border__bottom">
          <h4 className="H2 page_margin30">{'Отправка налоговых документов в бумажном виде'}</h4>

          <div className="page_margin20">
            {'Адрес места жительства (места пребывания при отсутствии места жительства):'}
            <br />
            {contactInfo.address}
          </div>

          {!appConfig.isInspectorArm && !readOnly ? this.renderHardCopyLink() : null}
          <br />
          {!REACT_CONFIG.REACT_APP_HIDE_1AFORM && !config.isInspectorArm && (
            <div className="page_margin20">
              <Link href={routeMap.setAddressToSendingTaxDocuments}>
                {'Изменить адрес для отправки налоговых документов'}
              </Link>
            </div>
          )}
        </div>
        {REACT_CONFIG.REACT_APP_HIDE_TOUR ? null : (
          <div className="white-block_border white-block_border__bottom">
            <Link href={routeMap.home} onClick={this.handleResetTourClick}>
              {'Посмотреть обучающий тур по личному кабинету налогоплательщика'}
            </Link>
          </div>
        )}

        {REACT_CONFIG.REACT_APP_HIDE_SURVEY || config.isInspectorArm ? null : (
          <div className="white-block_border white-block_border__bottom">
            <Link href={routeMap.survey}>{'Пройти опросник для выбора налоговых услуг'}</Link>
          </div>
        )}

        {!readOnly && !appConfig.isInspectorArm ? (
          <a href={remotePaths.rejectLKFL}>{'Отказаться от пользования личным кабинетом'}</a>
        ) : null}
      </div>
    );
  };

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__middle">
        <Loading />
      </div>
    );
  };

  render() {
    const { loading, hasError } = this.props;

    if (hasError) {
      return <Warning />;
    }

    if (loading) {
      return this.renderLoading();
    }

    return this.renderContentInfo();
  }
}
